import * as Yup from 'yup';

// Search Enquiries validation schema
export const SearchEnquiriesSchema = Yup.object().shape({
  createdBefore: Yup.date().test(
    'dateToTest',
    'To date should be after than from date',
    function (value: any) {
      const { createdAfter } = this.parent;
      if (value && createdAfter && createdAfter.isAfter(value)) return false;
      return true;
    }
  ),
  digStartBefore: Yup.date().test(
    'dateToTest',
    'To date should be after than from date',
    function (value: any) {
      const { digStartAfter } = this.parent;
      if (value && digStartAfter && digStartAfter.isAfter(value)) return false;
      return true;
    }
  ),
  jobNumber: Yup.string().matches(/^\d*$/, 'Numeric characters only'),
  referralId: Yup.string().matches(/^\d*$/, 'Numeric characters only')
});
